import { Container } from '@material-ui/core';
import React from 'react';
import { InfoForm } from './../../../components/InfoForm';
export const InformationComponent = (props: any) => (
  <Container maxWidth='md'>
    <InfoForm {...props} />
  </Container>
);
